import LogoIcon from '../../assets/images/logo-50x50.svg';
import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_stage_wizard/StageDetailsForm.scss';
import Button from '../../components/Button';
import {
  __,
  getLocalized,
  mapStateToProps,
  setTableParams,
} from '../../core/utils';
import ArrowRightMiddleIcon from '../../assets/images/arrow-right-middle-15x15.svg';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import DateTimePicker from '../../components/DateTimePicker';
import Checkbox from '../../components/Checkbox';
import classNames from 'classnames';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import Select from '../../components/Select';
import Tooltip from '../../components/Tooltip';
import Localization from '../../helpers/Localization';
import { subscribe } from 'react-contextual';
import * as _ from 'lodash';
import { listPlanningLibraryItems } from '../../redux/actions/table/planning_library';

@reduxForm({
  form: 'add_stage_wizard.stage_details',
  destroyOnUnmount: false,
})
@subscribe(Localization, 'localization')
@mapStateToProps((state) => ({
  application_language_id: state.auth.language_id,
}))
class StageDetailsForm extends Component {
  state = {
    planningLibraryItems: [],
  };

  componentDidMount() {
    listPlanningLibraryItems('stage', false, true).then(({ response }) => {
      this.setState({
        planningLibraryItems: _.map(
          response.data,
          (item) => ({
            value: item.id,
            label: [
              getLocalized(item.name, this.props.application_language_id),
              item.code,
            ].filter(Boolean).join(' - '),
            icon: (
              <Tooltip
                text={item.is_system
                  ? __('planning-templates.source.system')
                  : __('planning-templates.source.my-company')}
              >
                <span
                  className={classNames(
                    styles.planningTemplateSource,
                    item.is_system ? styles.systemSource : styles.companySource,
                  )}
                >
                  {item.is_system ? <LogoIcon /> : 'MY'}
                </span>
              </Tooltip>
            ),
          })
        ),
      });
    });
  }

  render() {
    const { localization, application_language_id } = this.props;

    const application_languages = _.transform(
      _.filter(
        _.get(localization, 'languages', []),
        (language) => language.application_language == true
      ),
      (languages, language) => {
        languages[language.id] = language.id == application_language_id;
        return languages;
      },
      {}
    );

    const statuses = [
      {
        value: 'not-started',
        label: __('stages.status.not-started'),
        color: '#9C27B0',
      },
      {
        value: 'started',
        label: __('stages.status.started'),
        color: '#5777FC',
      },
      {
        value: 'finished',
        label: __('stages.status.finished'),
        color: '#ADD42B',
      },
      {
        value: 'closed',
        label: __('stages.status.closed'),
        color: '#009688',
      },
      {
        value: 'reopened',
        label: __('stages.status.reopened'),
        color: '#303F9F',
      },
      {
        value: 'canceled',
        label: __('stages.status.canceled'),
        color: '#CCCDD1',
      },
    ];

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='status'
              component={Select}
              label={__('stage.status')}
              options={statuses}
              noSort
              dropdown
              wrapper={(handleOpen, activeItem, elementRef) => (
                <Tooltip text={__('stage.status')}>
                  <div
                    className={styles.dropdown}
                    ref={elementRef}
                    style={{ background: activeItem.color }}
                    onClick={handleOpen}
                  >
                    <div className={styles.button}>
                      {activeItem.label}
                      <ArrowDownSmallIcon />
                    </div>
                  </div>
                </Tooltip>
              )}
            />
          </div>
          <div className={styles.f1} />
        </div>
        <Field
          name='name'
          component={Input}
          localized={this.props.projectLanguages}
          label={__('project.stages.column.title')}
          maxLength={50}
        />
        <Field
          name='stage_template_id'
          component={Select}
          noSort
          searchable
          label={__('project.stages.column.template')}
          options={this.state.planningLibraryItems}
        />
        <Field
          name='description'
          localized={this.props.projectLanguages}
          component={Textarea}
          label={__('project.stages.column.description')}
          maxLength={100}
          rows={1}
          maxRows={10}
        />
        <div className={styles.flex}>
          <div className={styles.f2}>
            <Field
              name='date'
              component={DateTimePicker}
              label={__('project.stages.column.date-range')}
              footer
              range
            />
          </div>
          <div className={classNames(styles.f1, styles.deadline)}>
            <div className={styles.deadlineLabel}>
              {__('project.stages.column.deadline')}
            </div>
            <Field
              name='date.deadline'
              component={Checkbox}
              className={styles.checkbox}
              onChange={(event) => {}}
              // disabled={disabled}
            />{' '}
          </div>

          <div className={classNames(styles.f1, styles.estimate)}>
            <Field
              name='time_log.planned_time'
              component={Input}
              label={__('project.stages.planned-time')}
              placeholder={__('project.stages.enter-planned-time')}
              // disabled={disabled}
            />
          </div>
        </div>

        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={() =>
              setTableParams('stages', {
                wizard_active: undefined,
              })
            }
          />
          <Button
            submit
            medium
            gray
            leftText={__('button.next')}
            rightIcon={ArrowRightMiddleIcon}
            spinning={this.props.submitting}
          />
        </div>
      </Form>
    );
  }
}

export default StageDetailsForm;
